import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, Zap, Infinity as InfinityIcon } from 'lucide-react';
import { trackAddToCart } from '../utils/metaPixel';
export function OfferSection() {
  return <section id="offer" className="py-24 bg-trino-burgundy relative overflow-hidden" data-id="element-87">
      {/* Decorative background */}
      <div className="absolute inset-0 opacity-10" data-id="element-88">
        <svg width="100%" height="100%" xmlns="http://www.w3.org/2000/svg" data-id="element-89">
          <defs data-id="element-90">
            <pattern id="hexagons" width="50" height="43.4" patternUnits="userSpaceOnUse" patternTransform="scale(2)" data-id="element-91">
              <path d="M25 0L50 14.4v28.9L25 43.3L0 28.9V14.4z" fill="none" stroke="#ffe471" strokeWidth="1" data-id="element-92" />
            </pattern>
          </defs>
          <rect width="100%" height="100%" fill="url(#hexagons)" data-id="element-93" />
        </svg>
      </div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-94">
        <motion.div initial={{
        opacity: 0,
        y: 40
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="bg-white rounded-3xl p-8 sm:p-12 shadow-2xl text-center border-4 border-trino-gold/30" data-id="element-95">
          <h2 className="text-3xl sm:text-4xl font-serif font-bold text-trino-burgundy mb-4" data-id="element-96">
            Tu Nuevo Comienzo
          </h2>
          <p className="text-lg text-trino-dark/70 mb-8 max-w-2xl mx-auto" data-id="element-97">
            Hoy puedes acceder al Perfil Trino Express + Todo el Bundle de
            Recursos por una inversión única.{' '}
            <span className="font-bold text-trino-coral" data-id="element-98">
              No es formación, es transformación.
            </span>
          </p>

          <div className="bg-trino-cream/50 rounded-2xl p-8 mb-8 inline-block w-full max-w-md border border-trino-peach" data-id="element-99">
            <p className="text-sm font-bold text-trino-gold-dark uppercase tracking-widest mb-2" data-id="element-100">
              Precio Especial 50%OFF
            </p>
            <div className="flex items-center justify-center" data-id="element-101">
              <span className="text-6xl font-bold text-trino-burgundy" data-id="element-102">
                6,39
              </span>
              <span className="text-2xl font-bold text-trino-burgundy ml-2 mt-4" data-id="element-103">
                USD
              </span>
            </div>
          </div>

          <div className="flex flex-col sm:flex-row justify-center items-center space-y-4 sm:space-y-0 sm:space-x-8 mb-10 text-sm text-trino-dark/60 font-medium" data-id="element-104">
            <div className="flex items-center" data-id="element-105">
              <Zap className="w-4 h-4 mr-2 text-trino-gold" data-id="element-106" /> Descarga
              inmediata
            </div>
            <div className="flex items-center" data-id="element-107">
              <InfinityIcon className="w-4 h-4 mr-2 text-trino-gold" data-id="element-108" /> Acceso
              de por vida
            </div>
            <div className="flex items-center" data-id="element-109">
              <ShieldCheck className="w-4 h-4 mr-2 text-trino-gold" data-id="element-110" /> Pago
              seguro
            </div>
          </div>

          <motion.a href="https://unanuevaconciencia.com/cart/47748104421594:1" target="_blank" rel="noopener noreferrer" onClick={() => trackAddToCart()} whileHover={{
          scale: 1.05
        }} whileTap={{
          scale: 0.95
        }} className="inline-block w-full sm:w-auto bg-gradient-to-r from-trino-gold to-trino-gold-dark text-white font-bold text-xl px-10 py-5 rounded-xl shadow-[0_10px_25px_-5px_rgba(212,168,83,0.5)] hover:shadow-[0_15px_30px_-5px_rgba(212,168,83,0.6)] transition-all duration-300" data-id="element-111">
            QUIERO MI PERFIL TRINO AHORA
          </motion.a>

          <p className="mt-6 text-trino-dark/50 text-sm" data-id="element-112">
            Tu nuevo comienzo empieza con un clic.
          </p>
        </motion.div>
      </div>
    </section>;
}